class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[data-search-input]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);

function initMainSearch() {
  document.removeEventListener('DOMContentLoaded', initMainSearch);

  const predictive = document.querySelector('predictive-search');
  const link = document.getElementById('predictive-search-link');
  const target = document.getElementById('real-result-count');
  if (!predictive || !link || !target) return;

  predictive.addEventListener('predictive-search:render', () => {
    fetch(link.href)
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const span = doc.getElementById('real-search-count');
        const num = span?.textContent.trim().match(/\d+/)?.[0] || '0';
        target.textContent = num;
      });
  });


  const productsTab = document.getElementById('tab-products');
  const blogsTab = document.getElementById('tab-blogs');
  const productGridContainer = document.querySelector('#ProductGridContainer');
  const reactMount = document.querySelector('#react-mount-plp');
  const cards = document.querySelectorAll('#product-grid li[data-type]');

  const url = new URL(window.location.href);
  let typeParam = url.searchParams.get('type');

  if (!typeParam) {
    url.searchParams.set('type', 'product');
    window.location.href = url.toString();
    return;
  }

  const setActive = (tab) => {
    tab.classList.add('border-b-2', 'border-black', 'text-navy');
    tab.classList.remove('text-navy');
  };

  const clearActive = (tab) => {
    tab.classList.remove('border-b-2', 'border-black', 'text-navy');
    tab.classList.add('text-navy');
  };

  const updateView = (type) => {
    if (type === 'product') {
      setActive(productsTab);
      clearActive(blogsTab);
      productGridContainer?.classList.remove('weezie-blog');
      reactMount?.classList.remove('hidden');
    } else if (type === 'article') {
      setActive(blogsTab);
      clearActive(productsTab);
      productGridContainer?.classList.add('weezie-blog');
      reactMount?.classList.add('hidden');
    }

    // cards.forEach((card) => {
    //   card.classList.toggle('hidden', card.dataset.type !== type);
    // });
  };

  updateView(typeParam);

  productsTab.addEventListener('click', () => {
    url.searchParams.set('type', 'product');
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  blogsTab.addEventListener('click', () => {
    url.searchParams.set('type', 'article');
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });
}

document.addEventListener('DOMContentLoaded', initMainSearch);
